module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": _vm.style,
      "heading": _vm.heading,
      "show-text": _vm.showText,
      "button-size": "mini",
      "disableButton": !_vm.isManager('property|finance') || _vm.renewalDays > 365 || _vm.renewal.saved,
      "button-text": _vm.buttonText,
      "button-icon": _vm.icon
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('renewal', {
    attrs: {
      "tenancy-data": _vm.tenancy,
      "site-data": _vm.site
    },
    on: {
      "change": _vm.renewalChanges
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84df39d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/RenewalAction.vue
// module id = 1583
// module chunks = 0